import { HashLink as Link } from "react-router-hash-link";
import React from "react";
import TableContainer from "@material-ui/core/TableContainer";
import { Paper } from "@material-ui/core";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
    table: {
        minWidth: 650,
    },
    anchortop: {
        display: "block",
        position: "relative",
        top: "-150px",
        visibility: "hidden",
    },
    anchor: {
        display: "block",
        position: "relative",
        top: "-90px",
        visibility: "hidden",
    },
});

export default function TeamDetail(props) {
    const classes = useStyles();

    for (let k of Object.keys(props.teams)) {
        props.teams[k].teamMembers = [];
    }

    for (let [k,v] of Object.entries(props.individuals)) {
        v.id = k;
        props.teams[v.teamId].teamMembers.push(v);
    }

    let keys = Object.keys(props.teams);
    keys.sort((a, b) =>
        props.teams[a].name < props.teams[b].name ? -1 : 1
    );

    return (
        <div>
            {keys.map((key, i) => {
                return (
                    <div key={key} style={{ textAlign: "left", marginBottom: "50px" }}>
                        <div className={i === 0 ? classes.anchortop : classes.anchor} id={key} />
                        <b>{props.teams[key].name}</b>
                        <TableContainer component={Paper}>
                            <Table className={classes.table} aria-label="simple table">
                                <TableHead>
                                    <TableRow style={{ backgroundColor: "#efefef" }}>
                                        <TableCell>
                                            <b>Round</b>
                                        </TableCell>
                                        <TableCell>
                                            <b>Opponent</b>
                                        </TableCell>
                                        <TableCell>
                                            <b>Result</b>
                                        </TableCell>
                                        <TableCell align="right"><b>PP20</b></TableCell>
                                        <TableCell align="right"><b>15</b></TableCell>
                                        <TableCell align="right"><b>10</b></TableCell>
                                        <TableCell align="right"><b>-5</b></TableCell>
                                        <TableCell align="right"><b>P/N</b></TableCell>
                                        <TableCell align="right"><b>G/N</b></TableCell>
                                        <TableCell align="right"><b>TUH</b></TableCell>
                                        <TableCell align="right"><b>PPTUH</b></TableCell>
                                        <TableCell align="right"><b>BH</b></TableCell>
                                        <TableCell align="right"><b>BP</b></TableCell>
                                        <TableCell align="right"><b>PPB</b></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {props.teams[key].rounds.map((round, i) => {
                                        return round.roomNumber ? (
                                            <TableRow key={i}>
                                                <TableCell>{i + 1}</TableCell>
                                                <TableCell>{round.opponentName}</TableCell>
                                                <TableCell>
                                                    <Link className="about" to={`/results/scoreboard#round${i+1}room${round.roomNumber}`}>
                                                    {round.win ? "W " : "L "}
                                                    {round.score}-{round.opponentScore}
                                                    </Link>
                                                </TableCell>
                                                <TableCell align="right">
                                                    {(round.tuh / 20).toFixed(1)}
                                                </TableCell>
                                                <TableCell align="right">{round.power}</TableCell>
                                                <TableCell align="right">{round.ten}</TableCell>
                                                <TableCell align="right">{round.neg}</TableCell>
                                                <TableCell align="right">
                                                    {round.neg === 0
                                                        ? "—"
                                                        : (round.power / round.neg).toFixed(2)}
                                                </TableCell>
                                                <TableCell align="right">
                                                    {round.neg === 0
                                                        ? "—"
                                                        : ((round.power + round.ten) / round.neg).toFixed(
                                                            2
                                                        )}
                                                </TableCell>
                                                <TableCell align="right">{round.tuh}</TableCell>
                                                <TableCell align="right">
                                                    {round.tuh === 0
                                                        ? 0
                                                        : (
                                                            (round.power * 15 +
                                                                round.ten * 10 -
                                                                round.neg * 5 + round.bp) /
                                                            round.tuh
                                                        ).toFixed(2)}
                                                </TableCell>
                                                <TableCell align="right">
                                                    {round.bh}
                                                </TableCell>
                                                <TableCell align="right">
                                                    {round.bp}
                                                </TableCell>
                                                <TableCell align="right">
                                                    {round.bh === 0 ? 0 : (round.bp / round.bh).toFixed(2)}
                                                </TableCell>
                                            </TableRow>
                                        ) : (
                                            <React.Fragment key={i} />
                                        );
                                    })}
                                    <TableRow style={{ backgroundColor: "#ffece3" }}>
                                        <TableCell />
                                        <TableCell>
                                            Total
                                        </TableCell>
                                        <TableCell />
                                        <TableCell align="right">
                                            {(props.teams[key].tuh / 20).toFixed(1)}
                                        </TableCell>
                                        <TableCell align="right">{props.teams[key].power}</TableCell>
                                        <TableCell align="right">{props.teams[key].ten}</TableCell>
                                        <TableCell align="right">{props.teams[key].neg}</TableCell>
                                        <TableCell align="right">
                                            {props.teams[key].neg === 0
                                                ? "—"
                                                : (props.teams[key].power / props.teams[key].neg).toFixed(2)}
                                        </TableCell>
                                        <TableCell align="right">
                                            {props.teams[key].neg === 0
                                                ? "—"
                                                : ((props.teams[key].power + props.teams[key].ten) / props.teams[key].neg).toFixed(
                                                    2
                                                )}
                                        </TableCell>
                                        <TableCell align="right">{props.teams[key].tuh}</TableCell>
                                        <TableCell align="right">
                                            {props.teams[key].tuh === 0
                                                ? 0
                                                : (
                                                    (props.teams[key].power * 15 +
                                                        props.teams[key].ten * 10 -
                                                        props.teams[key].neg * 5 + props.teams[key].bp) /
                                                    props.teams[key].tuh
                                                ).toFixed(2)}
                                        </TableCell>
                                        <TableCell align="right">
                                            {props.teams[key].bh}
                                        </TableCell>
                                        <TableCell align="right">
                                            {props.teams[key].bp}
                                        </TableCell>
                                        <TableCell align="right">
                                            {props.teams[key].bh === 0 ? 0 : (props.teams[key].bp / props.teams[key].bh).toFixed(2)}
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <TableContainer component={Paper} style={{marginTop:"30px"}}>
                            <Table className={classes.table} aria-label="simple table">
                                <TableHead>
                                    <TableRow style={{backgroundColor:"#efefef"}}>
                                        <TableCell><b>Player</b></TableCell>
                                        <TableCell><b>Team</b></TableCell>
                                        <TableCell align="right"><b>GP</b></TableCell>
                                        <TableCell align="right"><b>15</b></TableCell>
                                        <TableCell align="right"><b>10</b></TableCell>
                                        <TableCell align="right"><b>-5</b></TableCell>
                                        <TableCell align="right"><b>P/N</b></TableCell>
                                        <TableCell align="right"><b>G/N</b></TableCell>
                                        <TableCell align="right"><b>TUH</b></TableCell>
                                        <TableCell align="right"><b>PPTUH</b></TableCell>
                                        <TableCell align="right"><b>PTS</b></TableCell>
                                        <TableCell align="right"><b>PP20</b></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {props.teams[key].teamMembers.map((player, i) => {
                                        return (
                                            <TableRow key={i}>
                                                <TableCell>
                                                <Link className="about" to={`/results/individualdetail#${player.id}`}>{player.name}</Link>
                                                </TableCell>
                                                <TableCell>
                                                    {player.team}
                                                </TableCell>
                                                <TableCell align="right">
                                                    {(player.tuh / 20).toFixed(1)}
                                                </TableCell>
                                                <TableCell align="right">{player.power}</TableCell>
                                                <TableCell align="right">{player.ten}</TableCell>
                                                <TableCell align="right">{player.neg}</TableCell>
                                                <TableCell align="right">
                                                    {player.neg === 0
                                                        ? "—"
                                                        : (player.power / player.neg).toFixed(2)}
                                                </TableCell>
                                                <TableCell align="right">
                                                    {player.neg === 0
                                                        ? "—"
                                                        : ((player.power + player.ten) / player.neg).toFixed(
                                                            2
                                                        )}
                                                </TableCell>
                                                <TableCell align="right">{player.tuh}</TableCell>
                                                <TableCell align="right">
                                                    {player.tuh === 0
                                                        ? 0
                                                        : (
                                                            (player.power * 15 +
                                                                player.ten * 10 -
                                                                player.neg * 5) /
                                                            player.tuh
                                                        ).toFixed(2)}
                                                </TableCell>
                                                <TableCell align="right">
                                                    {player.power * 15 +
                                                    player.ten * 10 -
                                                    player.neg * 5}
                                                </TableCell>
                                                <TableCell align="right">
                                                    {player.tuh === 0
                                                        ? 0
                                                        : (
                                                            (player.power * 15 +
                                                                player.ten * 10 -
                                                                player.neg * 5) /
                                                            player.tuh * 20
                                                        ).toFixed(2)}
                                                </TableCell>
                                            </TableRow>
                                        )
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>
                );
            })}
        </div>
    );
}
